import React, { Component } from 'react';
import Spinner from '../components/spinner';
import { connect } from 'react-redux';
import { resetReducer } from '../../containers/Auth/auth.action';

class ResetPasswordView extends Component {
    inputChanged (key, value, loading) {
        if (loading) return;
        this.props.inputChanged(key, value);
    }

    componentWillMount () {
        this.props.resetReducer();
    }

    renderFirstStage (loading, email) {
        console.log(this.props.error);
        return (
            <div>
                <div style={{display: 'flex', flexWrap: 'wrap'}}>
                    <div className='input-field-wrapper'>
                        {/* <img src={inputText} className='input-field-background' /> */}
                        {/* <div className='input-field-inner-wrapper'> */}
                        <input type='email' value={email} name='email' placeholder='Email' className='input-field'
                            onChange={(e) => this.inputChanged('email', e.target.value, loading)} />
                        {/* </div> */}
                    </div>
                    <ErrorRenderer condition={this.props.error !== null} message={this.props.error} />
                </div>
                {
                    !loading
                        ? <div className='container-buttons'>
                            <div className='btn block login'
                                onClick={() => this.props.requestPasswordCode(email)}>
                                <h4>Enviar código para email</h4>
                            </div>
                        </div>
                        : <Spinner />
                }
                <div className='container-buttons'>
                    <div
                        className='btn block login'
                        onClick={() => this.props.history.push('/')}>
                        <h4>Voltar</h4>
                    </div>
                </div>
            </div>
        );
    }

    renderSecondStage (loading, email, code) {
        return (
            <div>
                <div style={{display: 'flex', flexWrap: 'wrap'}}>
                    <br />
                    <br />
                    <br />
                    {/* <div className='input-field-wrapper'>
                    <img src={inputText} className='input-field-background' />
                    <div className='input-field-inner-wrapper'>
                        <input type='email' value={email} name='email' placeholder='Email' className='input-field'
                            onChange={(e) => this.inputChanged('email', e.target.value, loading)} />
                    </div>
                </div> */}
                    <div className='input-field-wrapper'>
                        {/* <div className='input-field-inner-wrapper'> */}
                        <input placeholder='Codigo' value={code} className='input-field'
                            onChange={(e) => this.inputChanged('code', e.target.value, loading)} />
                        {/* </div> */}
                    </div>
                    <ErrorRenderer condition={this.props.error !== null} message={this.props.error} />
                </div>
                {
                    !loading
                        ? <div className='container-buttons'>
                            <div className='btn block login'
                                onClick={() => this.props.validateCode(email, code)}>
                                <h4>Validar código</h4>
                            </div>
                        </div>
                        : <Spinner />
                }
                <div className='container-buttons'>
                    <div
                        className='btn block login'
                        onClick={() => this.props.history.push('/')}>
                        <h4>Voltar</h4>
                    </div>
                </div>
            </div>
        );
    }

    renderThirdStage (loading, email, code, password, rePassword) {
        return (
            <div>
                <div style={{display: 'flex', flexWrap: 'wrap'}}>
                    <br />
                    <br />
                    <br />
                    {/* <div className='input-field-wrapper'>
                    <img src={inputText} className='input-field-background' />
                    <div className='input-field-inner-wrapper'>
                        <input type='email' value={email} name='email' placeholder='Email' className='input-field'
                            onChange={(e) => this.inputChanged('email', e.target.value, loading)} />
                    </div>
                    </div>
                    <div className='input-field-inner-wrapper'>
                        <input placeholder='Codigo' value={code} className='input-field'
                            onChange={(e) => this.inputChanged('password', e.target.value, loading)} />
                    </div>
                    <br />
                    <br />
                    <br /> */}
                    {/* <div className='input-field-inner-wrapper'> */}
                    <div className='input-field-wrapper'>
                        <input type='password' placeholder='Nova senha' value={password} className='input-field'
                            onChange={(e) => this.inputChanged('password', e.target.value, loading)} />
                        {/* </div> */}
                    </div>
                    <br />
                    <br />
                    <br />
                    {/* <div className='input-field-inner-wrapper'> */}
                    <div className='input-field-wrapper'>
                        <input type='password' placeholder='Repite sua nova senha' value={rePassword}
                            className='input-field'
                            onChange={(e) => this.inputChanged('rePassword', e.target.value, loading)} />
                        {/* </div> */}
                    </div>
                    <ErrorRenderer condition={this.props.error !== null} message={this.props.error} />
                </div>
                {
                    !loading
                        ? <div className='container-buttons'>
                            <div className='btn block login'
                                onClick={() => this.props.changePassword(email, code, password, rePassword)}>
                                <h4>Mudar senha</h4>
                            </div>
                        </div> : <Spinner />
                }
                <div className='container-buttons'>
                    <div
                        className='btn block login'
                        onClick={() => this.props.history.push('/')}>
                        <h4>Voltar</h4>
                    </div>
                </div>
            </div>
        );
    }

    renderForthStage () {
        return <div>
            <div style={{display: 'flex', flexWrap: 'wrap'}}>
                Senha alterada com sucesso.
            </div>
            <div className='container-buttons'>
                <div
                    className='btn block login'
                    onClick={() => this.props.history.push('/')}>
                    <h4>Voltar</h4>
                </div>
            </div>
        </div>;
    }

    renderStage (loading, stage, input) {
        let {email, code, password, rePassword} = input;
        if (stage === 1) {
            return (
                // responsible for getting the user email and sending it to api
                this.renderFirstStage(loading, email)
            );
        } else if (stage === 2) {
            return (
                // responsible for getting the code that was sent to the email, and validating it
                this.renderSecondStage(loading, email, code)
            );
        } else if (stage === 3) {
            return (
                // responsible for reseting the password
                this.renderThirdStage(loading, email, code, password, rePassword)
            );
        } else if (stage === 4) {
            return (
                this.renderForthStage()
            );
        }
    }

    render () {
        const stage = this.props.resetPasswordStage;
        let loading = this.props.loading;
        let error = this.props.error;
        return (
            <div className='auth-background resetPassword'>
                {this.renderStage(loading, stage, this.props.input)}
                <ErrorRenderer error={error} condition={error} />
            </div>

        );
    }
}

const ErrorRenderer = (props) => {
    return (
    <div className='auth-error-container'>
        <div className='auth-error-wrapper'>
            {
                props.condition
                ? <span className='auth-error-message'>{props.message}</span>
                : null
        }
        </div>
    </div>
)};

export default connect(null, {resetReducer})(ResetPasswordView);



// WEBPACK FOOTER //
// ./src/views/AuthViews/resetPasswordView.js